// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Disable the Edge browser's built-in eye icon */
input[type=password]::-ms-reveal {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/components/Login/EmailLogin/loginWithEmail.scss"],"names":[],"mappings":"AAAA,iDAAA;AACA;EACI,aAAA;AACJ","sourcesContent":["/* Disable the Edge browser's built-in eye icon */\ninput[type=\"password\"]::-ms-reveal {\n    display: none;\n  }\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
